import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as ChartMobileImg} from '../../assets/chat02/chart-mobile.svg';
import {ReactComponent as ChartImg} from '../../assets/chat02/chart.svg';
import {ReactComponent as SearchImg} from '../../assets/chat02/search.svg';
import {ReactComponent as TableImg} from '../../assets/chat02/table.svg';

export default function Chat02() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    const dataMap = [
        { 
            type: 'table',
            title: '표 형식의 답변',
            subTitle: '복잡한 DB 정보는 표 형식으로 답변해 드려요',
            Image: TableImg
        },
        { 
            type: 'chart',
            title: '그래프 형식의 답변',
            subTitle: '표, 그래프 등 원하는 방식으로 데이터를 볼 수 있어요',
            Image: mobileSmall ? ChartMobileImg : ChartImg
        }
    ];

    return (
        <FeatureCardBox
            type='data'
            IconImage={SearchImg}
            keyword='정보 검색'
            title={mobileSmall ? <>DB를 기반으로<br /> 실시간 데이터를 찾아드려요!</> : 'DB를 기반으로 실시간 데이터를 찾아드려요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
            motionVariant={serviceMotionList.chat02}
        />
    );
}
